module.exports = __webpack_public_path__ + "ws.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/ws.svg
// module id = 1144
// module chunks = 0